import { type CanActivateFn } from '@angular/router';
import type { ParameterValidator } from '../parameter-validator/parameter-validator';
import { intParameterValidator } from '../parameter-validator/int-parameter.validator';
import { floatParameterValidator } from '../parameter-validator/float-parameter.validator';
import { stringParameterValidator } from '../parameter-validator/string-parameter.validator';
import { booleanParameterValidator } from '../parameter-validator/boolean-parameter.validator';
import { hasParameterGuard } from '../common/has-parameter.guard';

export const hasPathParamCanActivateGuard =
  (key: string, parameterValidator: ParameterValidator, path?: string[]): CanActivateFn =>
  route =>
    hasParameterGuard(key, route.params[key], parameterValidator, path);

export const hasIntPathParamCanActivateGuard = (key: string, path?: string[]): CanActivateFn =>
  hasPathParamCanActivateGuard(key, intParameterValidator, path);

export const hasDoublePathParamCanActivateGuard = (key: string, path?: string[]): CanActivateFn =>
  hasPathParamCanActivateGuard(key, floatParameterValidator, path);

export const hasStringPathParamCanActivateGuard = (key: string, path?: string[]): CanActivateFn =>
  hasPathParamCanActivateGuard(key, stringParameterValidator, path);

export const hasBooleanPathParamCanActivateGuard = (key: string, path?: string[]): CanActivateFn =>
  hasPathParamCanActivateGuard(key, booleanParameterValidator, path);
